/* ToveGolf brand layer — small, dependency-free. Dawn handles cart/menus/search. */
(function(){
'use strict';
var reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
var $$=function(s,c){return Array.prototype.slice.call((c||document).querySelectorAll(s))};

/* reveal on scroll (once). Re-runs for sections added by the theme editor. */
function reveal(root){
  var els=$$('.tg-reveal',root||document);
  if(reduce||!('IntersectionObserver' in window)){els.forEach(function(e){e.classList.add('is-in')});return;}
  var io=new IntersectionObserver(function(es){es.forEach(function(en){if(en.isIntersecting){en.target.classList.add('is-in');io.unobserve(en.target);}})},{threshold:.15});
  els.forEach(function(e){io.observe(e)});
}

/* count-up numbers: <span data-tg-count="188" data-dec="0"> */
function countUp(root){
  $$('[data-tg-count]',root||document).forEach(function(el){
    if(el.dataset.done) return;
    var end=parseFloat(el.dataset.tgCount),dec=+(el.dataset.dec||0);
    if(reduce||!('IntersectionObserver' in window)){el.textContent=end.toFixed(dec);el.dataset.done=1;return;}
    var io=new IntersectionObserver(function(es){
      if(!es[0].isIntersecting) return; io.disconnect(); el.dataset.done=1;
      var start=null,dur=1100;
      (function step(ts){if(!start)start=ts;var p=Math.min(1,(ts-start)/dur);p=1-Math.pow(1-p,3);el.textContent=(end*p).toFixed(dec);if(p<1)requestAnimationFrame(step);})(performance.now());
    },{threshold:.4});
    io.observe(el);
  });
}

/* shop-the-look hotspots */
function hotspots(root){
  $$('[data-tg-look]',root||document).forEach(function(sec){
    if(sec.dataset.wired) return; sec.dataset.wired=1;
    var spots=$$('.tg-hotspot',sec);
    function closeAll(){spots.forEach(function(s){s.setAttribute('aria-expanded','false');var c=sec.querySelector('#'+s.getAttribute('aria-controls'));if(c)c.classList.remove('is-open');});}
    spots.forEach(function(s){
      s.addEventListener('click',function(e){
        e.stopPropagation();
        var card=sec.querySelector('#'+s.getAttribute('aria-controls'));
        var open=s.getAttribute('aria-expanded')!=='true';
        closeAll();
        if(open&&card){s.setAttribute('aria-expanded','true');card.classList.add('is-open');}
        var m=sec.querySelector('.tg-look__row [data-card="'+s.dataset.hot+'"]');
        if(m){$$('.tg-look__row article',sec).forEach(function(a){a.classList.remove('is-hot')});m.classList.add('is-hot');m.scrollIntoView({behavior:reduce?'auto':'smooth',block:'nearest',inline:'center'});}
      });
    });
    document.addEventListener('click',closeAll);
    document.addEventListener('keydown',function(e){if(e.key==='Escape')closeAll();});
  });
}

/* review carousel: arrows + dots + optional autoplay */
function reviewCarousels(root){
  $$('[data-tg-revcar]',root||document).forEach(function(car){
    if(car.dataset.wired) return; car.dataset.wired=1;
    var view=car.querySelector('.tg-revcar__view'),dots=car.querySelector('.tg-revcar__dots'),prev=car.querySelector('.tg-revcar__arrow--prev'),next=car.querySelector('.tg-revcar__arrow--next');
    var auto=car.dataset.autoplay==='true',every=+(car.dataset.interval||5000),pages=1,timer=null,idle=null,visible=false;
    function pageCount(){return Math.max(1,Math.round(view.scrollWidth/view.clientWidth))}
    function current(){return Math.round(view.scrollLeft/view.clientWidth)}
    function go(i,wrap){i=wrap?(i+pages)%pages:Math.max(0,Math.min(pages-1,i));view.scrollTo({left:i*view.clientWidth,behavior:reduce?'auto':'smooth'});}
    function sync(){var c=current();$$('button',dots).forEach(function(d,i){d.classList.toggle('is-on',i===c);d.setAttribute('aria-selected',i===c)});if(prev)prev.disabled=c<=0;if(next)next.disabled=c>=pages-1;}
    function build(){pages=pageCount();dots.innerHTML='';for(var i=0;i<pages;i++){(function(idx){var b=document.createElement('button');b.type='button';b.setAttribute('role','tab');b.setAttribute('aria-label','Page '+(idx+1));b.addEventListener('click',function(){go(idx);hold();});dots.appendChild(b);})(i);}sync();}
    function play(){if(!auto||reduce||timer||!visible||pages<2)return;timer=setInterval(function(){go(current()+1,true)},every);}
    function stop(){clearInterval(timer);timer=null;}
    function hold(){stop();clearTimeout(idle);idle=setTimeout(play,8000);}
    var t=false;view.addEventListener('scroll',function(){if(!t){t=true;requestAnimationFrame(function(){t=false;sync();});}},{passive:true});
    if(prev)prev.addEventListener('click',function(){go(current()-1);hold();});
    if(next)next.addEventListener('click',function(){go(current()+1);hold();});
    view.addEventListener('keydown',function(e){if(e.key==='ArrowRight'){e.preventDefault();go(current()+1);hold();}if(e.key==='ArrowLeft'){e.preventDefault();go(current()-1);hold();}});
    ['pointerdown','wheel','touchstart'].forEach(function(ev){view.addEventListener(ev,hold,{passive:true})});
    view.addEventListener('mouseenter',stop);view.addEventListener('mouseleave',play);
    var rt;window.addEventListener('resize',function(){clearTimeout(rt);rt=setTimeout(build,180)});
    if('IntersectionObserver' in window){new IntersectionObserver(function(es){visible=es[0].isIntersecting;visible?play():stop();},{threshold:.25}).observe(view);}else{visible=true;play();}
    build();
  });
}

function init(root){reveal(root);countUp(root);hotspots(root);reviewCarousels(root);}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){init()});else init();
/* theme editor: re-init when a section is (re)loaded */
document.addEventListener('shopify:section:load',function(e){init(e.target)});
})();
